module.exports = __webpack_public_path__ + "static/yatagan_logo-8e8e52b5245204851f251c0b0c3b6695.png";